import KPI from 'models/kpi/kpi';
import { FormVersionEventActor } from 'models/tasks/formVersion';
import TaskType from 'models/tasks/taskType';

export class KPIDefinitionPreview {
  previewToken: string;

  definitionHash: string;

  kpiId: number;

  currentDefinitionRevisionId: number;

  affectedCatalogFamilyCount: number;

  affectedPrivateOrManagedFamilyCount: number;

  affectedTaskCount: number;

  requiresConfirmation: boolean;

  affectedCatalogFamilyNames: string[];

  inaccessibleCatalogFamilyCount: number;

  compatibilityBlockers: string[];

  constructor() {
    this.previewToken = '';
    this.definitionHash = '';
    this.kpiId = 0;
    this.currentDefinitionRevisionId = 0;
    this.affectedCatalogFamilyCount = 0;
    this.affectedPrivateOrManagedFamilyCount = 0;
    this.affectedTaskCount = 0;
    this.requiresConfirmation = false;
    this.affectedCatalogFamilyNames = [];
    this.inaccessibleCatalogFamilyCount = 0;
    this.compatibilityBlockers = [];
  }
}

export class KPIDefinitionCommitResult {
  kpi: KPI;

  kpiDefinitionRevisionId: number;

  updatedTaskTypes: TaskType[];

  constructor() {
    this.kpi = new KPI();
    this.kpiDefinitionRevisionId = 0;
    this.updatedTaskTypes = [];
  }
}

export class KPIDefinitionRevisionChoiceInfo {
  choiceKey: number;

  sortOrder: number;

  value?: string;

  description?: string;

  constructor() {
    this.choiceKey = 0;
    this.sortOrder = 0;
  }
}

export class KPIDefinitionRevisionInfo {
  kpiId: number;

  kpiDefinitionRevisionId: number;

  revision: number;

  isCurrent: boolean;

  type: number;

  minValue?: string;

  maxValue?: string;

  decimalCount: number;

  defValue?: string;

  required: boolean;

  attachmentMode?: number;

  commentMode?: number;

  showLabel: boolean;

  source: FormVersionEventActor;

  actorId?: string;

  created: Date;

  name?: string;

  description?: string;

  instruction?: string;

  expectedResult?: string;

  // The ordered choice snapshot of this revision, language-resolved like the texts above.
  choices: KPIDefinitionRevisionChoiceInfo[];

  constructor() {
    this.kpiId = 0;
    this.kpiDefinitionRevisionId = 0;
    this.revision = 0;
    this.isCurrent = false;
    this.type = 0;
    this.decimalCount = 0;
    this.required = false;
    this.showLabel = false;
    this.source = FormVersionEventActor.Human;
    this.created = new Date(0);
    this.choices = [];
  }
}

export class KPIDefinitionTextCorrectionMutation {
  kpiId: number;

  kpiDefinitionRevisionId: number;

  choiceKey?: number;

  languageId: number;

  name?: string;

  description?: string;

  instruction?: string;

  expectedResult?: string;

  choiceValue?: string;

  // A success/error definition's question. It is the definition's own defValue and not a translation,
  // so undefined means "leave the question as it is" rather than "clear it".
  question?: string;

  expectedDefinitionRevisionRowVersion?: string;

  expectedImpactHash?: string;

  constructor() {
    this.kpiId = 0;
    this.kpiDefinitionRevisionId = 0;
    this.languageId = 0;
  }
}
